import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'

export const DeleteConfirmationModal = withSafeSuspense(lazy(
  async () => ({ default: (await import('./confirmation')).DeleteConfirmationModal })
))
